import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { CookieConsent } from 'react-cookie-consent'
import { brandDarkGrey, brandOrange, brandSoftGrey, brandWhite } from '../../../assets/consts/color'
import { primaryFont } from '../../../assets/consts/fonts'
import CustomizeSettings from './CustomizeSettings'

const BannerWrapper = styled.div`
  .banner-container {
    align-items: center !important;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    background: ${brandDarkGrey} !important;

    & > div:first-child {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      flex-basis: 26em !important;
      gap: 15px;

      @media only screen and (min-width: 625px) {
        flex-wrap: nowrap;
      }
    }

    p {
      color: white;
    }

    button {
      font-family: ${primaryFont};
      font-style: normal;
      font-weight: 400;
      line-height: 120%;
    }

    .select-wrapper {
      padding: 6px 10px;
      border: 2px solid ${brandOrange};
    }

    .custom-cookie {
      /* padding: 6px 16px; */
      border: none;
      background: transparent;

      color: ${brandWhite};

      &:focus {
        outline: none;
      }

      option {
        color: ${brandSoftGrey};
        padding: 10px;
      }
    }

    .accept-button {
      background: ${brandOrange} !important;
      color: ${brandWhite} !important;
      padding: 8px 16px !important;
    }

    .decline-button {
      background: transparent !important;
      border: 2px solid ${brandOrange} !important;
      color: ${brandWhite} !important;
      padding: 8px 16px !important;
    }
  }
`

const declineCookieValue = {
  consents: {
    ad_storage: false,
    analytics_storage: false,
    ad_user_data: false,
    ad_personalization: false,
    personalization_storage: false,
    functionality_storage: true,
    security_storage: true,
  },
}
const declineCookieValueStr = JSON.stringify(declineCookieValue)

const acceptCookieValue = {
  consents: {
    ad_storage: true,
    analytics_storage: true,
    ad_user_data: true,
    ad_personalization: true,
    personalization_storage: true,
    functionality_storage: true,
    security_storage: true,
  },
}
const acceptCookieValueStr = JSON.stringify(acceptCookieValue)

function CookieBanner() {
  const [acceptCookieValueState, setAcceptCookieValueState] = useState(acceptCookieValue)
  const [settings, setSettings] = useState([
    {
      label: 'essential',
      value: true,
    },
    {
      label: 'analytics',
      value: true,
    },
    {
      label: 'marketing',
      value: true,
    },
  ])

  useEffect(() => {
    setAcceptCookieValueState(
      settings.reduce((acc, { label, value }) => {
        if (label === 'analytics') {
          return {
            consents: {
              ...acc.consents,
              analytics_storage: value,
            },
          }
        }

        if (label === 'marketing') {
          return {
            consents: {
              ...acc.consents,
              ad_storage: value,
              ad_user_data: value,
              ad_personalization: value,
              personalization_storage: value,
            },
          }
        }

        return acc
      }, acceptCookieValueState)
    )
  }, [settings])

  return (
    <BannerWrapper>
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Reject"
        cookieName="heliguy_tracking_consent"
        declineCookieValue={declineCookieValueStr}
        cookieValue={JSON.stringify(acceptCookieValueState)}
        containerClasses="banner-container"
        buttonClasses="accept-button"
        declineButtonClasses="decline-button"
        enableDeclineButton
        onAccept={() => window?.consentChange(acceptCookieValueState)}
        onDecline={() => window?.consentChange(declineCookieValue)}
      >
        <p>This website uses cookies to ensure you get the best experience on our website.</p>
        <CustomizeSettings settings={settings} onSelect={setSettings} />
      </CookieConsent>
    </BannerWrapper>
  )
}

export default CookieBanner
